webpackJsonp([2],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(42);

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786cc05a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_solstice_md__ = __webpack_require__(43);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786cc05a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_solstice_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('html',[_c('head'),_c('body',[_c('h1',[_vm._v("Solstice")]),_vm._v(" "),_c('p',[_vm._v("Waiting felt like an eternity "),_c('br'),_vm._v("\nUntil I could drink you in "),_c('br'),_vm._v("\nOne week, two weeks, three "),_c('br'),_vm._v("\nMay as well have been decades")]),_vm._v(" "),_c('p',[_vm._v("Our nights together "),_c('br'),_vm._v("\nThough few "),_c('br'),_vm._v("\nFelt like our private infinities "),_c('br'),_vm._v("\nLike life was on pause "),_c('br'),_vm._v("\nAnd it was just you and me "),_c('br'),_vm._v("\nEntangled, entranced "),_c('br'),_vm._v("\nTwo souls detached from the world "),_c('br'),_vm._v("\nAnd attached to each other")]),_vm._v(" "),_c('p',[_vm._v("We always woke up the next morning "),_c('br'),_vm._v("\nAnd went about our ways "),_c('br'),_vm._v("\nBut during those nights "),_c('br'),_vm._v("\nTime stopped being real "),_c('br'),_vm._v("\nAnd our realities became each other")]),_vm._v(" "),_c('p',[_vm._v("It is funny, isn't it? "),_c('br'),_vm._v("\nThat looking back it all feels so quick "),_c('br'),_vm._v("\nSuch a brief pocket of time "),_c('br'),_vm._v("\nJune to October "),_c('br'),_vm._v("\nYou were the brightest day "),_c('br'),_vm._v("\nMy summer solstice "),_c('br'),_vm._v("\nBut you were gone before the leaves had ceased falling "),_c('br'),_vm._v("\nI can count those months on one hand "),_c('br'),_vm._v("\nAnd those wonderful nights on the other "),_c('br'),_vm._v("\nWhat I can't count so easily are the times you reached me "),_c('br'),_vm._v("\nMade me smile, laugh, cry "),_c('br'),_vm._v("\nThe times you made me feel something real")]),_vm._v(" "),_c('p',[_vm._v("I wonder now do the trees forget their old leaves "),_c('br'),_vm._v("\nWhen the new ones come in spring? "),_c('br'),_vm._v("\nI don't know when my spring will come "),_c('br'),_vm._v("\nBut I don't want to forget my old leaves "),_c('br'),_vm._v("\nSo beautiful floating to the ground "),_c('br'),_vm._v("\nIn reds, yellows, browns "),_c('br'),_vm._v("\nFloating away from me "),_c('br'),_vm._v("\nLeaving me bare and exposed, sure "),_c('br'),_vm._v("\nBut the very thing that allowed me survive another year")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.eb0c8898af28a487d427.js